import React, { useEffect, useState } from 'react';
import { Dropdown } from '../helpers/Dropdown';
import { getBootstrapIcons } from '../../utils/utils';
import ColorBar from '../theme/ColorBar';
import { FileDrop } from '../helpers/FileDrop';
import { CharacterLimitIndicator } from '../helpers/CharacterLimitIndicator';
import RichTextEditor from './RichTextEditor';
import { TextInput } from '../helpers/TextInput';
import { useAuthContext, useUploadContext } from '../../store/Contexts';
import { InputField, SwitchField } from '../helpers/FormComponents';
import Tooltip from '../ui/tooltips/Tooltip';
import TagInput from '../helpers/TagInput';
import { uploadFile } from '../../services/containerService';
import Toast from '../ui/toasts/Toast';
import {
    formatFileSize,
    getAudioLength,
    getFileCategory,
    getImageDimensions,
    getVideoRuntime,
} from '../helpers/FileUtils';
import {
    createAsset,
    fetchAssets,
    fetchAssetByID,
} from '../../services/clientService';
import styles from '../assets/AssetLibrary.module.scss';
import AssetGridView from '../assets/components/AssetGridView';
import PaginationComponent from '../helpers/PaginationComponent';
import NotFoundBox from '../ui/no_data_indicators/NotFoundBox';
import { isValidFileTypeAndSize } from '../../utils/validate';
import { queryPortalPages } from '../../services/portalPageService';
import { sanitizeFileName } from '../helpers/FileUtils';
import { getText } from '../../i18n';

const PropertiesChildPortal = ({
    item,
    setItem,
    setUploadFile,
    handleUploadFromDevice,
    handleAddFromAssets,
    setIsSaving,
}) => {
    const { publicBrand } = useAuthContext();
    const { enqueueUpload } = useUploadContext();
    const [isAddFromAssetsChecked, setIsAddFromAssetsChecked] = useState('');
    const [isUploadFromDeviceChecked, setIsUploadFromDeviceChecked] =
        useState('');
    const [imageAsset, setImageAsset] = useState({});
    const [imageAsset1, setImageAsset1] = useState({});
    const [imageAsset2, setImageAsset2] = useState({});
    const [imageAsset3, setImageAsset3] = useState({});
    const [imageAsset4, setImageAsset4] = useState({});
    const [textAssets, setTextAssets] = useState([]);
    const [containerAssets, setContainerAssets] = useState([]);
    const [selectedContainerAssets, setSelectedContainerAssets] = useState([]);
    const [areInputsDisabled, setAreInputsDisabled] = useState(false);
    const [childPortalList, setChildPortalList] = useState([]);
    const [selectedChildPortal, setSelectedChildPortal] = useState({});
    const [isDisplayIcon, setIsDisplayIcon] = useState(true);
    const [file, setFile] = useState();
    const [selectedIcon, setSelectedIcon] = useState('');
    const [selectedBackgroundColor, setSelectedBackgroundColor] = useState(
        publicBrand.accessoryColor,
    );
    const [selectedForegroundColor, setSelectedForegroundColor] = useState(
        publicBrand.accessoryTextColor,
    );
    const [selectedButtonText, setSelectedButtonText] = useState('View');
    const [selectedCaption, setSelectedCaption] = useState('');
    const [initialText, setInitialText] = useState('');
    const [text, setText] = useState('');
    const [asset, setAsset] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [assets, setAssets] = useState([]);
    const [activeCard, setActiveCard] = useState(null);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    const handleChildPortalChange = (value, label) => {
        setSelectedChildPortal({ value: value, label: label });
    };

    function updateAsset(asset, key, value) {
        return { ...asset, [key]: value };
    }

    const uploadAsset = async () => {
        setIsSaving(true);

        if (!validateForm()) {
            setIsSaving(false);
            return;
        }

        let urlResponse;
        let isValidUrl = false;

        if (!asset.url) {
            try {
                const response = await enqueueUpload(file.name, uploadOptions =>
                    uploadFile(file, uploadOptions),
                );
                if (response.error) {
                    Toast.error(response.message);
                } else {
                    urlResponse = encodeURI(response);
                }
                try {
                    new URL(urlResponse);
                    isValidUrl = true;
                    setAsset(prev => ({
                        ...prev,
                        url: urlResponse,
                    }));
                } catch (error) {
                    Toast.error(getText('msg_3e298875de25'));
                }
            } catch (error) {
                Toast.error(getText('msg_3e298875de25'));
            }
        }

        if (isValidUrl || asset.url) {
            const newAsset = { ...asset };
            if (!newAsset.assetTypeId) newAsset.assetTypeId = 4; //ContentInProgress
            if (urlResponse) newAsset.url = urlResponse;
            newAsset.fileType = file.name.split('.').pop();
            newAsset.fileSize = formatFileSize(file.size);

            const fileCategory = getFileCategory(file.name);
            if (fileCategory === 'video') {
                newAsset.metaData = await getVideoRuntime(file);
            } else if (fileCategory === 'audio') {
                newAsset.metaData = await getAudioLength(file);
            } else if (fileCategory === 'image') {
                newAsset.metaData = await getImageDimensions(file);
            }

            const createResponse = await createAsset(newAsset, null);
            if (createResponse.error) {
                Toast.error(createResponse.message);
            } else if (
                createResponse.status === 200 &&
                createResponse.data.url
            ) {
                Toast.success(getText('msg_9309271e92fe'));
                switch (isUploadFromDeviceChecked) {
                    case 'image':
                        const imageAssets = [
                            imageAsset1,
                            imageAsset2,
                            imageAsset3,
                            imageAsset4,
                        ];
                        const assetSetters = [
                            setImageAsset1,
                            setImageAsset2,
                            setImageAsset3,
                            setImageAsset4,
                        ];

                        // Find the first empty slot
                        const emptyIndex = imageAssets.findIndex(
                            asset => !asset.url,
                        );

                        // Update the thumbnail and the internal image array
                        if (emptyIndex !== -1) {
                            assetSetters[emptyIndex]({
                                assetId: createResponse.data.id,
                                assetTypeId: createResponse.data.assetTypeId,
                                url: createResponse.data.url,
                            });
                        }
                        break;
                    case 'text':
                        setTextAssets(prevTextAssets => {
                            // Only add the asset if it doesn't already exist

                            const assetExists = prevTextAssets.some(
                                asset =>
                                    asset.assetId === createResponse.data.id,
                            );
                            if (!assetExists) {
                                return [
                                    ...prevTextAssets,
                                    {
                                        assetId: createResponse.data.id,
                                        assetTypeId:
                                            createResponse.data.assetTypeId,
                                        url: createResponse.data.url,
                                    },
                                ];
                            }
                            return prevTextAssets; // Return the previous state if the asset already exists
                        });
                        break;
                    default:
                        break;
                }
                setIsUploadFromDeviceChecked('');
                setAsset({});
                setFile(null);
            } else {
                Toast.error(getText('msg_9f8fd8f97fd3'));
            }
        }

        setIsSaving(false);
    };

    const validateForm = () => {
        if (!asset.name || asset.name.trim() === '') {
            Toast.error(getText('msg_d7659e2c4af2'));
            return false;
        }

        if (!file) {
            Toast.error(getText('msg_e11c5988bd25'));
            return false;
        }

        const fileTypeAndSizeValidation = isValidFileTypeAndSize(file);
        if (fileTypeAndSizeValidation) {
            Toast.error(fileTypeAndSizeValidation);
            return false;
        }

        if (asset.name.length > 256) {
            Toast.error(getText('msg_f4231db74e51'));
            return false;
        }

        return true;
    };

    useEffect(() => {
        if (isAddFromAssetsChecked) {
            loadAssets();
        }
    }, [currentPage, searchTerm]);

    const handleSearch = event => {
        setSearchTerm(event.target.value);
    };

    const handleClick = index => {
        setActiveCard(activeCard === index ? null : index);
    };

    const addAsset = () => {
        if (activeCard === null) {
            return Toast.error(
                getText('msg_c9d0d3fc9172'),
                null,
                getText('msg_40f0bdba0938'),
            );
        }

        const assetAdding = assets[activeCard];
        switch (isAddFromAssetsChecked) {
            case 'image':
                const imageAssets = [
                    imageAsset1,
                    imageAsset2,
                    imageAsset3,
                    imageAsset4,
                ];
                const assetSetters = [
                    setImageAsset1,
                    setImageAsset2,
                    setImageAsset3,
                    setImageAsset4,
                ];

                // Find the first empty slot
                const emptyIndex = imageAssets.findIndex(asset => !asset.url);

                // Update the thumbnail and the internal image array
                if (emptyIndex !== -1) {
                    assetSetters[emptyIndex]({
                        assetId: assetAdding.id,
                        url: assetAdding.url,
                    });
                }
                break;
            case 'text':
                setTextAssets(prevTextAssets => {
                    // Only add the asset if it doesn't already exist

                    const assetExists = prevTextAssets.some(
                        asset => asset.assetId === assetAdding.id,
                    );
                    if (!assetExists) {
                        return [
                            ...prevTextAssets,
                            { assetId: assetAdding.id, url: assetAdding.url },
                        ];
                    }
                    return prevTextAssets; // Return the previous state if the asset already exists
                });
                break;
            default:
                break;
        }
        setIsAddFromAssetsChecked('');
        setSearchTerm('');
        setAssets([]);
        setTotalPages(1);
        setCurrentPage(1);
        setActiveCard(null);
    };

    useEffect(() => {
        handleUploadFromDevice(isUploadFromDeviceChecked);
    }, [isUploadFromDeviceChecked]);

    const loadAssets = async () => {
        setIsSaving(true);
        try {
            let queryParams = {
                assetTypes: [1, 2],
                page: currentPage,
                pageSize: 12,
                fileTypes: ['jpg', 'jpeg', 'png', 'svg'],
            };
            if (searchTerm !== '' && searchTerm !== ' ') {
                queryParams = { ...queryParams, search: searchTerm };
            }
            const fetchedAssets = await fetchAssets(queryParams, null, false);
            setAssets(fetchedAssets.viewModels);
            setTotalPages(fetchedAssets.pageTotal);
        } catch (error) {
            console.error('Failed to fetch assets', error);
            Toast.error(getText('msg_cade149a85b2'));
        }
        setIsSaving(false);
    };

    useEffect(() => {
        if (isAddFromAssetsChecked) {
            loadAssets();
        }
        handleAddFromAssets(isAddFromAssetsChecked);
    }, [isAddFromAssetsChecked]);

    useEffect(() => {
        if (isDisplayIcon) {
            setImageAsset({});
        }
    }, [isDisplayIcon]);

    useEffect(() => {
        let imagesUrls = [];
        if (isNotEmptyObject(imageAsset1)) imagesUrls.push(imageAsset1.url);
        if (isNotEmptyObject(imageAsset2)) imagesUrls.push(imageAsset2.url);
        if (isNotEmptyObject(imageAsset3)) imagesUrls.push(imageAsset3.url);
        if (isNotEmptyObject(imageAsset4)) imagesUrls.push(imageAsset4.url);

        setItem(prevState => {
            const { childPortalPart } = prevState;

            return {
                ...prevState,
                childPortalPart: {
                    ...childPortalPart,
                    childPortalId: selectedChildPortal.value,
                    glyph: isDisplayIcon ? selectedIcon : null,
                    backgroundColor: isDisplayIcon
                        ? selectedBackgroundColor
                        : null,
                    foregroundColor: isDisplayIcon
                        ? selectedForegroundColor
                        : null,
                    images: isDisplayIcon ? null : imagesUrls,
                    caption: isDisplayIcon ? null : selectedCaption,
                    text: isDisplayIcon ? null : text,
                    buttonText: isDisplayIcon ? null : selectedButtonText,
                },
                containerAssets: containerAssets,
            };
        });
    }, [
        selectedIcon,
        selectedBackgroundColor,
        selectedForegroundColor,
        selectedChildPortal,
        selectedButtonText,
        selectedCaption,
        text,
        imageAsset1,
        imageAsset2,
        imageAsset3,
        imageAsset4,
        containerAssets,
    ]);

    // Array list of all Bootstrap v5.3 Icons extracted from https://icons.getbootstrap.com/sprite/
    // TODO: Replace with Emy's custom icon library once that one is ready
    const icons = getBootstrapIcons();

    // Filter the icon array by the user's search input
    const [filter, setFilter] = useState('');
    const filteredIcons = icons.filter(icon =>
        icon.toString().includes(filter.toLowerCase()),
    );

    const handleIconSelected = icon => {
        if (icon === selectedIcon) {
            setSelectedIcon('');
        } else {
            setSelectedIcon(icon);
        }
    };

    // Handle background color update
    const handleUpdateBackgroundColor = newSelection => {
        setSelectedBackgroundColor(newSelection.left);
    };

    // Handle foreground color update
    const handleUpdateForegroundColor = newSelection => {
        setSelectedForegroundColor(newSelection.left);
    };

    useEffect(() => {
        let childPortalArray = [];
        queryPortalPages(true).then(payload => {
            payload.viewModels.forEach(portalPage => {
                childPortalArray.push({
                    value: portalPage.id,
                    label: portalPage.name,
                });
                if (
                    item.hasOwnProperty('childPortalPart') &&
                    item.childPortalPart !== null
                ) {
                    if (item.childPortalPart.childPortalId === portalPage.id) {
                        setSelectedChildPortal({
                            value: portalPage.id,
                            label: portalPage.name,
                        });
                    }
                }
                setChildPortalList(childPortalArray);
            });
        });

        if (item !== undefined) {
            if (item.hasOwnProperty('templateStatus')) {
                if (item.templateStatus === -1) {
                    //Template is locked, activate view-only mode
                    setAreInputsDisabled(true);
                }
            }
        }
        if (
            item.hasOwnProperty('childPortalPart') &&
            item.childPortalPart !== null
        ) {
            if (item.childPortalPart.glyph !== null) {
                setIsDisplayIcon(true);
                setSelectedIcon(item.childPortalPart.glyph);
                setSelectedBackgroundColor(
                    item.childPortalPart.backgroundColor,
                );
                setSelectedForegroundColor(
                    item.childPortalPart.foregroundColor,
                );
            } else {
                setIsDisplayIcon(false);
                setSelectedButtonText(
                    item.childPortalPart.buttonText || 'View',
                );
                setSelectedCaption(item.childPortalPart.caption);
                setInitialText(item.childPortalPart.text);
                setText(item.childPortalPart.text);
            }
        }
    }, []);

    useEffect(() => {
        const fetchAssets = async () => {
            setIsLoading(true);
            if (item !== undefined) {
                if (
                    item.hasOwnProperty('containerAssets') &&
                    item.containerAssets !== null
                ) {
                    item.containerAssets = item.containerAssets.filter(
                        asset => Object.keys(asset).length > 0,
                    );
                    let tempImageAsset1 = {};
                    let tempImageAsset2 = {};
                    let tempImageAsset3 = {};
                    let tempImageAsset4 = {};
                    let tempTextAssets = [];

                    const orderedContainerAssets = item.containerAssets.sort(
                        (a, b) => a.assetOrder - b.assetOrder,
                    );
                    for (const containerAsset of orderedContainerAssets) {
                        if (containerAsset.assetId) {
                            const fetchedAsset = await fetchAssetByID(
                                containerAsset.assetId,
                                null,
                            );
                            containerAsset.url = fetchedAsset.url;
                            if (
                                item.childPortalPart.text.indexOf(
                                    containerAsset.url,
                                ) !== -1
                            ) {
                                const regex = new RegExp(
                                    `(<img[^>]+src=["']${containerAsset.url}["'][^>]+style=["']([^"']+)["'][^>]*>)`,
                                    'i',
                                );
                                const match =
                                    item.childPortalPart.text.match(regex);
                                let width = null;
                                let margin = null;

                                if (match && match[2]) {
                                    const style = match[2];
                                    const widthMatch =
                                        style.match(/width:\s*([^;]+)/);
                                    if (widthMatch) {
                                        width = widthMatch[1].trim();
                                    }
                                    const marginMatch =
                                        style.match(/margin:\s*([^;]+)/);
                                    if (marginMatch) {
                                        margin = marginMatch[1].trim();
                                    }
                                }
                                tempTextAssets.push({
                                    id: containerAsset.id,
                                    assetId: containerAsset.assetId,
                                    url: containerAsset.url,
                                    width: width,
                                    margin: margin,
                                });
                                continue;
                            }
                            if (!isNotEmptyObject(tempImageAsset1)) {
                                tempImageAsset1 = {
                                    id: containerAsset.id,
                                    assetId: containerAsset.assetId,
                                    url: containerAsset.url,
                                };
                            } else if (!isNotEmptyObject(tempImageAsset2)) {
                                tempImageAsset2 = {
                                    id: containerAsset.id,
                                    assetId: containerAsset.assetId,
                                    url: containerAsset.url,
                                };
                            } else if (!isNotEmptyObject(tempImageAsset3)) {
                                tempImageAsset3 = {
                                    id: containerAsset.id,
                                    assetId: containerAsset.assetId,
                                    url: containerAsset.url,
                                };
                            } else if (!isNotEmptyObject(tempImageAsset4)) {
                                tempImageAsset4 = {
                                    id: containerAsset.id,
                                    assetId: containerAsset.assetId,
                                    url: containerAsset.url,
                                };
                            }
                            continue;
                        }
                    }
                    setImageAsset1(tempImageAsset1);
                    setImageAsset2(tempImageAsset2);
                    setImageAsset3(tempImageAsset3);
                    setImageAsset4(tempImageAsset4);
                    setTextAssets(tempTextAssets);
                    setIsLoading(false);
                }
            }
        };

        fetchAssets(); // Call the async function

        // Cleanup function if needed
        return () => {
            // Cleanup logic if necessary
        };
    }, []);

    const handleFileChange = fileValue => {
        setFile(sanitizeFileName(fileValue));
    };

    // Function to handle the start of dragging
    const handleDragStart = (event, position) => {
        event.dataTransfer.setData('text/plain', position);
    };

    // Function to handle dropping
    const handleDrop = (event, newPosition) => {
        const oldPosition = event.dataTransfer.getData('text/plain');
        swapImages(parseInt(oldPosition, 10), newPosition);
        event.preventDefault();
    };

    // Function to swap images
    const swapImages = (oldIndex, newIndex) => {
        let newContainerAssets = [
            imageAsset1,
            imageAsset2,
            imageAsset3,
            imageAsset4,
        ];
        const temp2 = newContainerAssets[oldIndex];
        newContainerAssets[oldIndex] = newContainerAssets[newIndex];
        newContainerAssets[newIndex] = temp2;

        setImageAsset1(newContainerAssets[0]);
        setImageAsset2(newContainerAssets[1]);
        setImageAsset3(newContainerAssets[2]);
        setImageAsset4(newContainerAssets[3]);
    };

    // Enable dropping on div elements
    const handleDragOver = event => {
        event.preventDefault();
    };

    useEffect(() => {
        setContainerAssets([
            imageAsset1,
            imageAsset2,
            imageAsset3,
            imageAsset4,
            ...textAssets,
        ]);
    }, [imageAsset1, imageAsset2, imageAsset3, imageAsset4, textAssets]);

    const toggleThumbnailSelection = index => {
        const currentContainerAssets = [
            imageAsset1,
            imageAsset2,
            imageAsset3,
            imageAsset4,
        ];
        if (!currentContainerAssets[index]) {
            return;
        }

        const newContainerAssetSelection = [...selectedContainerAssets];
        const containerAssetPosition =
            newContainerAssetSelection.indexOf(index);
        if (containerAssetPosition > -1) {
            newContainerAssetSelection.splice(containerAssetPosition, 1);
        } else {
            newContainerAssetSelection.push(index);
        }
        setSelectedContainerAssets(newContainerAssetSelection);
    };

    const deleteSelectedThumbnails = () => {
        const containerAssetSetters = [
            setImageAsset1,
            setImageAsset2,
            setImageAsset3,
            setImageAsset4,
        ];
        selectedContainerAssets.forEach(index => {
            containerAssetSetters[index]({});
        });
        setSelectedContainerAssets([]);
    };

    const isNotEmptyObject = obj => {
        return obj && typeof obj === 'object' && Object.keys(obj).length > 0;
    };

    const allImageAssetsFilled =
        isNotEmptyObject(imageAsset1) &&
        isNotEmptyObject(imageAsset2) &&
        isNotEmptyObject(imageAsset3) &&
        isNotEmptyObject(imageAsset4);

    const handleImageCaptionChange = event => {
        setSelectedCaption(event.target.value);
    };

    const handleButtonLabelChange = event => {
        setSelectedButtonText(event.target.value);
    };

    const handleAssetDelete = assetId => {
        setContainerAssets(prevAssets =>
            prevAssets.filter(asset => asset.assetId !== assetId),
        );
    };

    return (
        <>
            <div
                style={{
                    display:
                        isUploadFromDeviceChecked || isAddFromAssetsChecked
                            ? 'none'
                            : 'block',
                }}
                className="file-form-label mt-5"
            >
                {getText('msg_6842c74c4d51')}
                <span
                    style={{
                        color: '#EF4E45',
                        marginLeft: '4px',
                        fontWeight: '500',
                    }}
                >
                    *
                </span>
            </div>
            <div
                style={{
                    display:
                        isUploadFromDeviceChecked || isAddFromAssetsChecked
                            ? 'none'
                            : 'block',
                }}
            >
                <Dropdown
                    defaultValue={selectedChildPortal.label || 'Select'}
                    options={childPortalList}
                    onChange={(value, label) =>
                        handleChildPortalChange(value, label)
                    }
                    disabled={areInputsDisabled}
                />
            </div>

            {/* RADIO BUTTON OPTIONS FOR DISPLAY: ICON / MULTIMEDIA */}
            <div
                className="mt-5"
                style={{
                    width: '100%',
                    minWidth: '100%',
                    display:
                        isUploadFromDeviceChecked || isAddFromAssetsChecked
                            ? 'none'
                            : 'block',
                }}
            >
                <div className="file-form-label">
                    {getText('msg_574ff9b0c49c')}
                    <span
                        style={{
                            color: '#EF4E45',
                            marginLeft: '4px',
                            fontWeight: '500',
                        }}
                    >
                        *
                    </span>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioURL"
                        id="flexRadioURL"
                        value="icon"
                        checked={isDisplayIcon === true}
                        onChange={() => setIsDisplayIcon(true)}
                        disabled={areInputsDisabled}
                    />
                    <label className="form-check-label" htmlFor="icon">
                        {getText('msg_716f63b96e0c')}
                    </label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioUpload"
                        id="flexRadioUpload"
                        value="multimedia"
                        checked={isDisplayIcon === false}
                        onChange={() => setIsDisplayIcon(false)}
                        disabled={areInputsDisabled}
                    />
                    <label className="form-check-label" htmlFor="multimedia">
                        {getText('msg_82dabd0bba3a')}
                    </label>
                </div>
            </div>

            {isDisplayIcon ? (
                // IF isDisplayIcon IS TRUE, RENDER ICON PICKER, ICON PREVIEW, AND COLOR PICKERS
                <>
                    {/* ICON PICKER WITH SEARCH BAR */}
                    <div style={{ marginTop: '20px' }}>
                        <input
                            type="text"
                            className="form-control mb-3"
                            placeholder={getText('msg_2f149aaf731c')}
                            onChange={e => setFilter(e.target.value)}
                            disabled={areInputsDisabled}
                        />
                        <div
                            style={{
                                border: '1px solid #2F2B4333',
                                borderRadius: '12px',
                                overflow: 'hidden',
                            }}
                        >
                            <div
                                className={`d-flex flex-wrap ${areInputsDisabled ? 'disabled' : ''}`}
                                style={{
                                    borderRadius: '12px',
                                    padding: '12px',
                                    height: '175px',
                                    overflow: areInputsDisabled
                                        ? 'hidden'
                                        : 'auto',
                                }}
                            >
                                {filteredIcons.map((icon, index) => (
                                    <div
                                        key={index}
                                        className={'px-2 d-flex'}
                                        style={{
                                            cursor: areInputsDisabled
                                                ? 'not-allowed'
                                                : 'pointer',
                                            backgroundColor:
                                                icon === selectedIcon
                                                    ? '#1366FF1A'
                                                    : 'transparent',
                                            outline:
                                                icon === selectedIcon
                                                    ? '1px solid #1366FF'
                                                    : 'none',
                                            borderRadius: '8px',
                                            aspectRatio: '1/1',
                                            height: 'fit-content',
                                            alignItems: 'center',
                                        }}
                                        onClick={() =>
                                            areInputsDisabled
                                                ? null
                                                : handleIconSelected(icon)
                                        }
                                    >
                                        <i
                                            className={'bi bi-' + icon}
                                            style={{ fontSize: '24px' }}
                                        ></i>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* ICON PREVIEW */}
                    {selectedIcon ? (
                        <div
                            className="d-flex mt-4"
                            style={{
                                alignItems: 'center',
                                gap: '10px',
                                flexDirection: 'column',
                            }}
                        >
                            <label className="form-check-label">
                                {getText('msg_2ca4886b4abf')}
                            </label>
                            <i
                                className={'bi bi-' + selectedIcon}
                                style={{
                                    fontSize: '2em',
                                    color: 'selectedForegroundColor',
                                }}
                            ></i>
                        </div>
                    ) : null}

                    {/* BACKGROUND COLOR PICKER */}
                    <div className="py-3">
                        <ColorBar
                            label={getText('msg_64dd60fe1a04')}
                            initialColors={{
                                left: selectedBackgroundColor,
                                right: selectedBackgroundColor,
                                type: 'single',
                            }}
                            onChangeComplete={handleUpdateBackgroundColor} // TODO: Create function
                            allowGradient={false}
                            toolTipText=""
                            startBelowHeader={true}
                        />
                    </div>

                    {/* FOREGROUND COLOR PICKER */}
                    <div className="py-3">
                        <ColorBar
                            label={getText('msg_f7745efdedae')}
                            initialColors={{
                                left: selectedForegroundColor,
                                right: selectedForegroundColor,
                                type: 'single',
                            }}
                            onChangeComplete={handleUpdateForegroundColor} // TODO: Create function
                            allowGradient={false}
                            toolTipText=""
                            startBelowHeader={true}
                        />
                    </div>
                </>
            ) : (
                // IF isDisplayIcon IS FALSE, RENDER MULTIMEDIA COMPOSER
                <>
                    <div
                        className="mt-5"
                        style={{
                            display:
                                areInputsDisabled ||
                                isUploadFromDeviceChecked ||
                                isAddFromAssetsChecked
                                    ? 'none'
                                    : 'block',
                        }}
                    >
                        <div
                            className="d-flex justify-content-center mb-4"
                            style={{
                                flexDirection: 'column',
                                gap: '24px',
                                display: allImageAssetsFilled
                                    ? 'none'
                                    : 'block',
                            }}
                        >
                            <button
                                style={{ width: '100%' }}
                                className={`button-base ing-button-primary-fit-content`}
                                onClick={() => {
                                    setIsAddFromAssetsChecked('image');
                                    setIsUploadFromDeviceChecked('');
                                }}
                            >
                                {getText('msg_27eb0a10db5c')}
                            </button>
                            <button
                                style={{ width: '100%' }}
                                className={`button-base button-secondary`}
                                onClick={() => {
                                    setIsUploadFromDeviceChecked('image');
                                    setIsAddFromAssetsChecked('');
                                }}
                            >
                                {getText('msg_c002fe6df29c')}
                            </button>
                        </div>
                        <>
                            <p
                                style={{
                                    color: 'gray',
                                    fontWeight: '500',
                                    margin: '16px 0',
                                }}
                            >
                                {' '}
                                {getText('msg_516c6ca63154')}
                            </p>
                            <div
                                style={{
                                    display: 'flex',
                                    height: '100%',
                                    width: '100%',
                                    margin: '20px 0',
                                    alignItems: 'center',
                                }}
                            >
                                {[
                                    imageAsset1,
                                    imageAsset2,
                                    imageAsset3,
                                    imageAsset4,
                                ].map((src, index) => (
                                    <div
                                        key={index}
                                        draggable={!!src.url}
                                        onDragStart={e =>
                                            handleDragStart(e, index)
                                        }
                                        onDrop={e => handleDrop(e, index)}
                                        onDragOver={handleDragOver}
                                        onClick={() =>
                                            toggleThumbnailSelection(index)
                                        }
                                        style={{
                                            flex: 1,
                                            cursor: src.url
                                                ? 'pointer'
                                                : 'auto',
                                            margin: '5px',
                                            height: '130px',
                                            backgroundImage: src.url
                                                ? `url("${src.url}")`
                                                : 'none',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            outlineColor: src.url
                                                ? '#1366ff'
                                                : 'lightgrey',
                                            outlineStyle:
                                                selectedContainerAssets.includes(
                                                    index,
                                                )
                                                    ? 'solid'
                                                    : 'dashed',
                                            outlineWidth:
                                                selectedContainerAssets.includes(
                                                    index,
                                                )
                                                    ? '4px'
                                                    : '1px',
                                            borderRadius:
                                                selectedContainerAssets.includes(
                                                    index,
                                                )
                                                    ? '8px'
                                                    : '0',
                                        }}
                                    ></div>
                                ))}
                                <span
                                    onClick={deleteSelectedThumbnails}
                                    disabled={!selectedContainerAssets.length}
                                    style={{
                                        margin: '10px 0',
                                        fontSize: '1.2em',
                                        color: 'red',
                                        cursor: 'pointer',
                                        marginLeft: '10px',
                                        display:
                                            selectedContainerAssets.length > 0
                                                ? 'block'
                                                : 'none',
                                    }}
                                >
                                    <i className="bi bi-trash3"></i>
                                </span>
                            </div>
                            <div
                                className="fw-medium"
                                style={{
                                    fontSize: '16px',
                                    color: 'rgba(47, 43, 67, 1)',
                                    margin: '10px 0',
                                }}
                            >
                                {getText('msg_792aa0ea12f8')}
                            </div>
                            <textarea
                                className="form-control"
                                style={{
                                    height: '100px',
                                    borderRadius: '12px',
                                    border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                    resize: 'none',
                                    padding: '16px',
                                }}
                                onChange={e => handleImageCaptionChange(e)}
                                placeholder={
                                    areInputsDisabled ? '' : '(Optional)'
                                }
                                defaultValue={selectedCaption || ''}
                                disabled={areInputsDisabled}
                            ></textarea>
                            <CharacterLimitIndicator
                                maxChars={50}
                                inputStr={selectedCaption || ''}
                            />
                        </>

                        {/* RICH TEXT EDITOR */}
                        <div className="file-form-label mt-5">
                            {getText('msg_c3328c39b0e2')}
                            <span
                                style={{
                                    color: '#EF4E45',
                                    marginLeft: '4px',
                                    fontWeight: '500',
                                }}
                            >
                                *
                            </span>
                        </div>
                        <div style={{ marginTop: '20px' }}>
                            {!isLoading && (
                                <RichTextEditor
                                    initialContent={initialText}
                                    onContentUpdate={setText}
                                    onUploadFromDevice={
                                        setIsUploadFromDeviceChecked
                                    }
                                    onAddFromAssets={setIsAddFromAssetsChecked}
                                    textAssets={textAssets}
                                    onAssetDelete={handleAssetDelete}
                                    disableAssetLink={true}
                                    disableHomeLink={true}
                                />
                            )}
                        </div>

                        {/* BUTTON */}
                        <div className="file-form-label mt-5">
                            {getText('msg_794145f030ff')}
                            <span
                                style={{
                                    color: '#EF4E45',
                                    marginLeft: '4px',
                                    fontWeight: '500',
                                }}
                            >
                                *
                            </span>
                        </div>
                        <input
                            onChange={e => handleButtonLabelChange(e)}
                            style={{
                                height: '48px',
                                width: '319px',
                                borderRadius: '12px',
                                border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                paddingLeft: '16px',
                                paddingRight: '16px',
                            }}
                            className="form-control"
                            type="text"
                            placeholder={getText('msg_a29e5384f6af')}
                            defaultValue={selectedButtonText}
                            disabled={areInputsDisabled}
                        ></input>
                        <CharacterLimitIndicator
                            maxChars={10}
                            inputStr={selectedButtonText || ''}
                        />
                    </div>
                </>
            )}

            {/* Upload From Device */}
            {isUploadFromDeviceChecked && (
                <>
                    <div style={{ width: '100%', paddingTop: '6px' }}>
                        <FileDrop file={file} onChange={handleFileChange} />
                    </div>

                    <InputField
                        label={getText('msg_709a23220f2c')}
                        onChange={value =>
                            setAsset(updateAsset(asset, 'name', value))
                        }
                        maxChars={256}
                        required={true}
                        placeholder={getText('msg_b7ffb9789f09')}
                        value={asset.name}
                    />

                    <div style={{ marginBottom: '24px' }}>
                        <div className="file-form-label">
                            {getText('msg_848eed0fbd54')}
                            <Tooltip
                                html="Use relevant and specific keywords to help make searching for an asset easier."
                                placement="right"
                            >
                                <i
                                    className="bi bi-info-circle"
                                    style={{
                                        paddingLeft: '5px',
                                        fontSize: '13px',
                                        color: 'var(--iNGAGED-Primary-Color)',
                                    }}
                                ></i>
                            </Tooltip>
                        </div>
                        <TagInput
                            onTagsChange={tags =>
                                setAsset(updateAsset(asset, 'assetTags', tags))
                            }
                            savedTags={asset.tags}
                        />
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <SwitchField
                            label={getText('msg_0c359a10ae17')}
                            onChange={isChecked =>
                                setAsset(
                                    updateAsset(
                                        asset,
                                        'assetTypeId',
                                        isChecked ? 4 : 5,
                                    ),
                                )
                            }
                            tooltip={getText('msg_77453f9dd036')}
                            checked={asset.assetTypeId !== 5} //UnassignedInProgress
                        />
                    </div>

                    <div
                        id="footer"
                        style={{
                            height: 'fit-content',
                            width: '100%',
                            padding: '28px',
                            display: isUploadFromDeviceChecked
                                ? 'block'
                                : 'none',
                        }}
                    >
                        <div
                            type="button"
                            style={{
                                height: '40px',
                                width: '128px',
                                textAlign: 'center',
                                display: 'inline-block',
                            }}
                            className="float-start button-base button-secondary"
                            onClick={() => setIsUploadFromDeviceChecked('')}
                        >
                            {getText('msg_77dfd2135f4d')}
                        </div>
                        <div
                            type="button"
                            style={{
                                height: '40px',
                                width: '128px',
                                textAlign: 'center',
                                display: 'inline-block',
                            }}
                            className="float-end button-base ing-button-primary-left"
                            onClick={() => uploadAsset()}
                        >
                            {getText('msg_61cc55aa0453')}
                        </div>
                    </div>
                </>
            )}

            {/* Add From Assets */}
            {isAddFromAssetsChecked && (
                <>
                    <div
                        className={styles.searchWrapper}
                        style={{ marginBottom: '26px' }}
                    >
                        <input
                            type="text"
                            className={styles.searchInput}
                            style={{ width: '100%' }}
                            placeholder={getText('msg_b18cdf8f03e9')}
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                        <span className={styles.searchIcon}>
                            <i className="bi bi-search"></i>
                        </span>
                    </div>

                    <AssetGridView
                        assets={assets}
                        propertiesModel={true}
                        handleClick={handleClick}
                        handleDoubleClick={() => null}
                        activeCard={activeCard}
                        fullAssetName={false}
                    />

                    {assets.length < 1 && (
                        <NotFoundBox
                            backgroundColor="#f0f4ff"
                            title={
                                searchTerm
                                    ? 'Sorry, no results found'
                                    : 'Sorry, there are no assets to display'
                            }
                            description={
                                searchTerm
                                    ? 'Try adjusting your search to find what you are looking for'
                                    : `You can upload a New Asset by clicking "Cancel" on the bottom left corner, then clicking on "Upload from Device"`
                            }
                        />
                    )}

                    <PaginationComponent
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />

                    <div
                        id="footer"
                        style={{
                            height: 'fit-content',
                            width: '100%',
                            padding: '28px',
                            display: isAddFromAssetsChecked ? 'block' : 'none',
                        }}
                    >
                        <div
                            type="button"
                            style={{
                                height: '40px',
                                width: '128px',
                                textAlign: 'center',
                                display: 'inline-block',
                            }}
                            className="float-start button-base button-secondary"
                            onClick={() => setIsAddFromAssetsChecked('')}
                        >
                            {getText('msg_77dfd2135f4d')}
                        </div>
                        <div
                            type="button"
                            style={{
                                height: '40px',
                                width: '128px',
                                textAlign: 'center',
                                display: 'inline-block',
                            }}
                            className="float-end button-base ing-button-primary-left"
                            onClick={() => addAsset()}
                        >
                            {getText('msg_61cc55aa0453')}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default PropertiesChildPortal;
